module.exports = __webpack_public_path__ + "img/news-slider1-zh.95707beb.jpg";